// extracted by mini-css-extract-plugin
export var menuIcon = "_qw-0";
export var menuIconInline = "_qw-1";